export default function Reducer(state, action) {
    switch (action.type) {
      case "ADD_TOKEN_TO_PORTFOLIO":
        return {
          ...state,
          portfolio: [action.payload, ...state.portfolio],
        };
      case "REMOVE_TOKEN_FROM_PORTFOLIO":
        return {
          ...state,
          portfolio: state.portfolio.filter(
            (token) => token.id !== action.payload.id
          ),
        };
      default: return {...state}
    }
  };